import React from 'react';
import firebaselib from 'firebase';
import firebaseui from 'firebaseui';
import firebase from '../util/fire';
import { Paper } from 'material-ui';

import 'firebaseui/dist/firebaseui.css';

const ui = new firebaseui.auth.AuthUI(firebase.auth());
const uiConfig = {
	callbacks: {
		signInSuccess: function(currentUser, credential, redirectUrl) {
			// User successfully signed in.
			// Return type determines whether we continue the redirect automatically
			// or whether we leave that to developer to handle.
			return true;
		}
	},
	// Will use popup for IDP Providers sign-in flow instead of the default, redirect.
	signInSuccessUrl: '/',
	signInOptions: [
		// Leave the lines as is for the providers you want to offer your users.
		firebaselib.auth.GoogleAuthProvider.PROVIDER_ID,
		firebaselib.auth.EmailAuthProvider.PROVIDER_ID
	]
};

class Login extends React.Component {

	componentDidMount() {
		ui.start('#firebaseui-auth-container', uiConfig);
	}

	render() {
		return (
			<div className="row">
				<div className="col" />
				<div className="col" style={{ maxWidth: "250px" }}>
					<br/>
					<Paper style={{ padding: '10px' }}>
						<h2>Login</h2>
						<p>Select your favorite authentication method</p>
						<div id="firebaseui-auth-container" />
					</Paper>
				</div>
				<div className="col" />
			</div>
		);
	}
}

export default Login;


// WEBPACK FOOTER //
// ./src/components/Login.js